/*
|--------------------------------------------------------------------------
| Wap根组件
|--------------------------------------------------------------------------
|
| 这里用来存放项目中所有的路由信息
|
*/
import React, { lazy, Suspense } from 'react'

import { HashRouter as Router, Route, Redirect } from 'react-router-dom'

import Layout from "./pages/Wap/Layout"

import { Auth, getStorage } from "./utils"

const AuthRoute = lazy(() => import( './components/AuthRoute'))
const Login = lazy(() => import('./pages/Wap/login'))
const ClientDetail = lazy(() => import('./pages/Wap/Client/detail'))

/**
 * 创建 App 组件
 * @constructor
 */
export default class AppPc extends React.PureComponent {
    render() {
        let default_route = Auth() ? getStorage('user').default_route : 'home'
        default_route = '/home/client'

        return (
            <Router>
                <Suspense fallback={<div className="router-loading">loading...</div>}>
                    <Route exact path="/" render={ () => <Redirect to={ default_route }  /> }/>
                    <AuthRoute path='/home' component={ Layout } />

                    <Route path="/login" component={ Login } />
                    <Route path="/clientDetail/:ids" component={ ClientDetail } />
                </Suspense>
            </Router>
        )
    }
}